import { useEffect, useRef, useState } from "react";
import { useOutsideClickHandler } from "../../../Hooks/useOutsideClick";
import Cross from '../../../Assets/Modals/closeIcon.svg';
import ChevronDown from '../../../Assets/ChevronDownLargeDarkMode.svg';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useOutsideClickForTwoRef } from "../../../Hooks/useOutsideClickForTwoRef";
import { showToast } from "../../../Components/Toaster/Toaster";
import { closeModal } from "../../../Features/inventoryManagementSlice";

const categories = [
    {
        id: 1,
        name: 'T-Shirt, Shirt, Top',
    },
    {
        id: 2,
        name: 'Trousers, Phants, Jeans',
    },
    {
        id: 3,
        name: 'Women Dresses',
    },
    {
        id: 4,
        name: 'Coat & Jacket',
    },
    {
        id: 5,
        name: 'Shoe & Sandals',
    },
    {
        id: 6,
        name: 'High Heels',
    },
    {
        id: 7,
        name: 'Clothing Set',
    },
];

function SelectModalType() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const wrapperRef = useRef(null);

    const dropdownButtonRef = useRef(null);
    const dropdownListRef = useRef(null);

    const [selectedCategory, setSelectedCategory] = useState({});

    const [buttonAvailable, setButtonAvailable] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    function handleDropdownButton() {
        setDropdownOpen(!dropdownOpen);
    }

    function handleSelectCategory(category) {
        setSelectedCategory(category);
    }

    useOutsideClickForTwoRef(dropdownButtonRef, dropdownListRef, () => {
        setDropdownOpen(false);
    });
    
    useOutsideClickHandler(wrapperRef, () => {
        handleCloseModal();
    });

    function handleCloseModal() {
        dispatch(closeModal());
    }

    function handleNext() {
        if(buttonAvailable) {
            localStorage.setItem('selectedCategory', selectedCategory);
            navigate('add-size-chart');
            dispatch(closeModal());
        }
        else {
            if(Object.keys(selectedCategory).length === 0) {
                showToast('Please select category.', 'warning');
            }
            return;
        }
    }

    useEffect(() => {
        if(Object.keys(selectedCategory).length > 0) {
            setButtonAvailable(true);
        }
        else {
            setButtonAvailable(false);
        }
    }, [selectedCategory]);

    return (
        <div ref={wrapperRef} className='w-[44%] bg-[#FFFFFF] border border-[#EAEAEA] rounded-[9px] p-4 flex flex-col gap-4 shadow-[0px_0px_12px_0px_#0000003D]'>
            <div className="flex flex-col gap-3">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <h1 className='font-semibold text-2xl text-[#121212]'>Size Chart</h1>
                    </div>
                
                    <button onClick={handleCloseModal} className="w-11 h-11 flex items-center justify-center">
                        <img src={Cross} alt="" />
                    </button>
                </div>

                <div className="flex flex-col gap-3">
                    <p className="text-[16px] leading-7 text-[#666666]">Category</p>

                    <div onClick={handleDropdownButton} ref={dropdownButtonRef} className={`relative cursor-pointer px-3 py-4 flex items-center justify-between gap-[10px] bg-[#F5F5F5] border border-[#EAEAEA] rounded-[9px] ${dropdownOpen && 'border-primaryColor'}`}>
                        <p className='font-normal w-[calc(100%-24px)] text-base text-[#666666] select-none'>
                            {Object.keys(selectedCategory).length > 0 ? (selectedCategory === 'Trousers, Phants, Jeans' ? 'Trousers, Pants, Jeans' : selectedCategory) : 'Select category'}
                        </p>

                        <div className="size-6 flex items-center justify-center select-none">
                            <img src={ChevronDown} alt="" />
                        </div>

                        {
                            dropdownOpen && 
                            <div ref={dropdownListRef} className="bg-[#FFFFFF] max-h-56 overflow-y-scroll absolute z-10 top-[58px] left-0 w-full rounded-[9px] shadow-[0px_3px_6px_0px_#0000001F]">
                                {categories?.sort((a, b) => a.name.localeCompare(b.name)).map(category => {
                                    return (
                                        <p key={category.id} onClick={() => handleSelectCategory(category.name)} className='px-3 py-4 font-medium text-base text-[#666666] select-none hover:bg-[#F5F5F5]'>{category.name === 'Trousers, Phants, Jeans' ? 'Trousers, Pants, Jeans' : category.name}</p>
                                    );
                                })}
                            </div>
                        }
                    </div>
                </div>
            </div>

            <button onClick={handleNext} className={`px-4 py-2 ${buttonAvailable ? 'bg-primaryColor hover:bg-primaryAccent' : 'bg-buttonDisabledBg cursor-not-allowed'} text-buttonText rounded font-semibold text-base`}>Next</button>
        </div>
    )
}

export default SelectModalType;
